module.exports = __webpack_public_path__ + "assets/e10ac678458246947dade1d5d8cb1203.png";